import 'arrayq';
import { createSelector } from 'reselect';
import { selectors as metaSelectors } from '../../meta/selectors';
import { PureConnect, React } from '../../react';
import Button from 'react-toolbox/lib/button/Button';
// import Caption from '../../shared/caption';
import { IBookmark, INote, INoteShared, IQuestion, IQuestionDB, isQuestion, isSharedNote, NoteAndParticipant } from '../../types';
import { bookmarksEditor, bookmarksResource } from '../bookmarks/resource';
import { categoriesEditor, categoriesResource } from '../categories/resource';
import { DataList } from '../datalist';
import { Modal } from '../modal/index';
import Navigator from '../notes/navigatorDetails';
import { notesEditor, notesResource } from '../notes/resource';
import { notesSharedEditor, notesSharedResource } from '../noteshared/resource';
import * as SlideView from '../slideView';
import TabsSelector from '../../react-toolbox-extended/tabs';
import selectors from './selectors';
import { selectors as pageFilterSelectors } from '../pageFilter/selectors';
import { bookmarksSelector, notesSelector } from '../pageFilter/selectors';
import PAGEFILTER_SHOW from '../pageFilter/actions/SHOW';
import PAGEFILTER_HIDE from '../pageFilter/actions/HIDE';
import SELECTION_REQUEST from '../selection/actions/REQUEST';
import TAB_ACTIVATE from './actions/TAB_ACTIVATE';
import UPDATED_BUTTON_LOCK from '../../focuslock/actions/UPDATED_BUTTON_LOCK';
import BUTTON_HIDE_FLYOVER from './actions/BUTTON_HIDE_FLYOVER';
import Wrapper from '../../focuslock/wrapper';
import cx from './style.less';
import '../../react-toolbox-redesign/icons.less';
import { buttonNotitiesToevoegenFlyover, originFlyover } from '../../focuslock/actions/UPDATE_BUTTON_NO';
import windowSelectors from '../../window/selectors';
import FocusLockFocusGuard from '../../focuslock/focuslockext';
import { Btn } from '../../react-toolbox-redesign/button';
import adminReselectors from '../admin/reselectors';
import NoteSelection from '../selection/selection';
import NoteSelectionSave from '../selection/selectionsave';
import FlyoverNotesEditLayout from '../notes/noteEditArea';
import { NotesSaveArea as NoteSaveArea } from '../notes/noteEditArea';
import { NoteDeleteArea, NoteDeleteAreaSave } from '../notes/noteDeleteArea';
import { CategoryPopupSelection, CategorySelectModelSaveArea } from '../categorySelectPopup/input';
import CategoriesEditArea, { CategoriesEditAreaButtons } from '../categories/categoryEditArea';
import ParticipantsSelectPopup from '../noteParticipantSelectPopup/input';
import { Navbar } from '../../shared/navbar';
import { indexNoteSelector, indexQuestionSelector, nextNoteSelector, nextQuestionSelector, prevNoteSelector, prevQuestionSelector } from '../notes/sortVisual';
import selectorsParticipantPopup from '../../note/noteParticipantSelectPopup/selectors';
import selectorsCategoryPopup from '../../note/categorySelectPopup/selectors';
import StatusArea from '../statusDialog/dialog';
import { AdminFilter, AdminFilterQuestions, AdminFilterRemoveAllFiltersButton } from '../filter/admin';
import REMOVE_ALL from '../filter/actions/REMOVEALL';
import NoItemsIcon from '../../react-toolbox-icons/noitems.svg';
import { notechatEditor } from '../notechat/resource';
import { NoteChatEditArea, NoteChatSaveArea } from '../notechat/editChatArea';
import { FlyoverQuestionEditLayout, QuestionSaveArea } from '../question/questionEditArea';
import { questionsEditor, questionsResource } from '../question/resource';
import { DeadLineLabelFlyover } from '../question/deadlineLabel/deadlineLabel';

const selectedNoteSelector = createSelector(
    notesEditor.selectors.reading, 
    notesEditor.selectors.updating,
    notesEditor.selectors.item,
    (reading, updating, item) => (((reading || updating) && item) || null) as INote);
const currentPageNotesSelector = createSelector(
    notesSelector,
    metaSelectors.pageId,
    (notes, pageId) => notes.qWhere((x) => !x.isquestion && x.pageId === pageId));
const currentPageQuestionsSelector = createSelector(
        notesSelector,
        metaSelectors.pageId,
        (notes, pageId) => notes.qWhere((x) => x.isquestion && x.pageId === pageId));    
const otherPageNotesSelector = createSelector(
    notesSelector,
    metaSelectors.pageId,
    (notes, pageId) => notes.qWhere((x) => !x.isquestion && x.pageId !== pageId));
const otherPageQuestionSelector = createSelector(
        notesSelector,
        metaSelectors.pageId,
        (notes, pageId) => notes.qWhere((x) => x.isquestion && x.pageId !== pageId));
const selectedSharedNoteSelector = createSelector(
    notesSharedEditor.selectors.reading, notesSharedEditor.selectors.updating,
    notesSharedEditor.selectors.item,
    (reading, updating, item) => (((reading || updating) && item) || null) as INote);
const currentPageBookmarksSelector = createSelector(
    bookmarksResource.selectors.items,
    metaSelectors.pageId,
    (bookmarks, pageId) => bookmarks.qWhere((x) => x.pageId === pageId));
const tagActiveBookmarksSelector = createSelector(
    bookmarksSelector,
    metaSelectors.pageId,
    (bookmarks, pageId) => bookmarks.qSelect((bookmark) => ({ ...bookmark, active: bookmark.pageId === pageId })));

const isLoadingSelector = createSelector(
    notesResource.selectors.loading,
    bookmarksResource.selectors.loading,
    categoriesResource.selectors.loading,
    notesSharedResource.selectors.loading,
    (notes, bookmarks, categories, notesparticipant) => notes || bookmarks || categories || notesparticipant,
);

const isReadingSelector = createSelector(
    notesEditor.selectors.reading,
    bookmarksEditor.selectors.reading,
    categoriesEditor.selectors.reading,
    notesSharedEditor.selectors.reading,
    (notes, bookmarks, categories, notesparticipant) => notes || bookmarks || categories || notesparticipant,
);
const isErrorSelector = createSelector(
    notesResource.selectors.error,
    bookmarksResource.selectors.error,
    categoriesResource.selectors.error,
    notesSharedResource.selectors.error,
    (notes, bookmarks, categories, sharednotes) => notes || bookmarks || categories || sharednotes,
);

export const Flyover = PureConnect(`Flyover`)(
    (state) => ({
        allBookmarks: bookmarksResource.selectors.items(state),
        allQuestions: questionsResource.selectors.items(state),
        currentPageBookmarks: currentPageBookmarksSelector(state),
        currentPageNotes: currentPageNotesSelector(state),
        currentPageQuestions: currentPageQuestionsSelector(state),
        participants: adminReselectors.participantsSelector(state),    
        docId: metaSelectors.docId(state),
        filterVisible: pageFilterSelectors.visible(state),
        isError: isErrorSelector(state),
        isLoading: isLoadingSelector(state),
        isReading: isReadingSelector(state),
        deleting: notesEditor.selectors.deleting(state),
        creating: notesEditor.selectors.creating(state),
        updating: notesEditor.selectors.updating(state),
        updatingNoteChat: notechatEditor.selectors.updating(state),   
        note: selectedNoteSelector(state),
        noteShared: selectedSharedNoteSelector(state),
        otherPageNotes: otherPageNotesSelector(state),
        otherPageQuestions: otherPageQuestionSelector(state),
        pageFilterVisible: pageFilterSelectors.visible(state),
        visibleSelect: state.selection.creating,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),
        pageId: metaSelectors.pageId(state),
        pageName: metaSelectors.pageName(state),
        pageNumber: metaSelectors.pageNumber(state),
        pageUrl: metaSelectors.pageUrl(state),
        tabIndex: selectors.tabIndex(state),
        tagActiveBookmarks: tagActiveBookmarksSelector(state),
        visible: state.flyover.visible,
        selectNote: state.selection.creating,
        selectTextArea: state.selection.creating, 
        screenSmall: windowSelectors.small(state),   
        index: indexNoteSelector(state),
        indexQuestion: indexQuestionSelector(state),
        next: nextNoteSelector(state),
        prev: prevNoteSelector(state),   
        nextQuestion: nextQuestionSelector(state),
        prevQuestion: prevQuestionSelector(state),        
    }),
    (dispatch) => ({
        removeAll: () => dispatch(REMOVE_ALL({})),  
        activateTab: (index: number) => dispatch(TAB_ACTIVATE({ index })),
        addBookmark: (item: IBookmark) => {
            fixNoteDevelopmentJsonServer(item);
            dispatch(bookmarksResource.actions.CREATE({ item: bookmarksResource.create(item) as IBookmark }));
        },
        initiateNewNote: () => dispatch(SELECTION_REQUEST({})),
        refresh: (documentId: string): void => {
            dispatch(notesResource.actions.LIST({ params: { documentId } }));
            dispatch(notesSharedResource.actions.LIST({ params: { documentId } }));
            dispatch(bookmarksResource.actions.LIST({ params: { documentId } }));
            dispatch(categoriesResource.actions.LIST({ params: { documentId } }));
        },
        removeBookmark: (item: IBookmark) => dispatch(bookmarksResource.actions.DELETE({ item })),
        showFilter: () => dispatch(PAGEFILTER_SHOW({ })),
        closeFilter: () => dispatch(PAGEFILTER_HIDE({ })),
        close: () => dispatch(BUTTON_HIDE_FLYOVER({ })),        
        change: (item: INote | any) => {dispatch(notesEditor.actions.APPLY({ item }));},
        readQuestion: (item: INote|INoteShared|IQuestion, allQuestions: IQuestionDB[]) => {
            if (!!isSharedNote(item)) {
                dispatch(notesEditor.actions.READ_CANCEL({})); 
                dispatch(notesSharedEditor.actions.READ({ item })); 
            } else {
                dispatch(notesSharedEditor.actions.READ_CANCEL({}));
                dispatch(notesEditor.actions.READ({ item })); 
            }
            var readquestion = false;
            if (isQuestion(item)) {
                var current = allQuestions.qWhere((x) => x.noteId === item.id).qFirst();
                if (current) {                               
                    dispatch(questionsEditor.actions.READ({ item: current })); 
                    readquestion = true; 
                }
            } 
            
            if (isQuestion(item) && !readquestion) {
                dispatch(questionsEditor.actions.READ_CANCEL({}));
            }
        },
        read: (item: INote|INoteShared) => {
            if (!!isSharedNote(item)) {
                dispatch(notesEditor.actions.READ_CANCEL({})); 
                dispatch(notesSharedEditor.actions.READ({ item })); 
            } else {
                dispatch(notesSharedEditor.actions.READ_CANCEL({}));
                dispatch(notesEditor.actions.READ({ item })); 
            }
        },        
        cancelNoteRead: () => dispatch(notesEditor.actions.READ_CANCEL({})),
        resetNotes: () => dispatch(notesResource.actions.RESET({ })),    
        resetSharedNotes: () => dispatch(notesSharedResource.actions.RESET({ })),                           
    }),
    ({
        note, noteShared, visible, isError, currentPageNotes, currentPageQuestions, participants,
        otherPageNotes, otherPageQuestions, tagActiveBookmarks, pageId, pageName, tabIndex, screenSmall, activateTab,
        initiateNewNote, showFilter, closeFilter, close, refresh, addBookmark, resetNotes, resetSharedNotes, docId,
        pageFilterVisible, visibleSelect, participantPopupVisible, categoryPopupVisible, creating, updating, deleting, updatingNoteChat,
        index, indexQuestion, read, readQuestion, prev, next, prevQuestion, nextQuestion, selectNote, selectTextArea, allQuestions,
    }) => {
        (window as any).refreshnotes = () => refresh(docId);
        (window as any).resetnotes = () => {resetNotes(); resetSharedNotes();};

        const addCurrentBookmark = () => {
            const name = pageName;
            const id = undefined as number;
            const categoryId = undefined as number;
            const created = undefined as string;
            const lastEdited = undefined as string;
            const pageNumber = undefined as number;
            const status = undefined as string;
            const url = undefined as string;
            addBookmark({ categoryId, created, id, lastEdited, name, pageNumber, status, url, pageId });
        };

        if (isError) {
            return (
                <Modal visible={visible} type={screenSmall ? 'smallscreen' :'flyover' }>
                    <div className={cx('status-message')}>
                        <p>Er ging iets mis bij het laden</p>
                        <Button onClick={() => refresh(docId)} accent>Opniew Proberen</Button>
                    </div>
                </Modal>
            );
        }     

        const slideFilter = 0;
        const slideList = 1;
        const slideDetails = 2;             
        const panel0 = 0; // notes
        const panel1 = 1; // questions
        const panel2 = 2; // bookmarks
        var navbarVisible =!(creating || updating || selectNote || selectTextArea || deleting || updatingNoteChat );
        var selectionclass = participantPopupVisible ? 'participant-select':
                                    categoryPopupVisible ? 'category-select':
                                        visibleSelect ? 'select-note':
                                            creating || updating || selectTextArea ? 'note-edit': 
                                                updatingNoteChat ? 'note-chat-edit' : 
                                                    pageFilterVisible ? 'filter-select' : 
                                                        note || noteShared || deleting ? 'navigation-notes': 'slide-list';
        
        return (       
            !visible?   null:  
                <Modal onEscKeyDown={close} backdrop={false} visible={visible} type={screenSmall ? 'smallscreen' :'flyover' }>                    
                    <div className={cx(selectionclass, !visible? 'wcag-invisible' : '')}  aria-hidden={!visible} aria-label= "selectie van notities en vragenlijsten">
                        <StatusArea />
                        <FocusLockFocusGuard 
                            disabled={!visible}>                              
                        <SlideView.Switch activeIndex={(pageFilterVisible ? slideFilter : (note || noteShared || deleting || visibleSelect||creating || updating ? slideDetails: slideList))}>
                            <SlideView.Panel> {/* ***slideFilter = 0*** */}
                                <div className={cx('tab-buttons')}>     
                                    <Btn
                                        type="button"
                                        className={cx('btn-icon-text_back', 'icon_arrow-back')}                                       
                                        aria-label={'Terug gaan'}
                                        aria-haspopup={true}
                                        tabIndex={0}
                                        onClick={() => closeFilter()}
                                        disabled={false}>
                                        <span>Terug</span>
                                    </Btn>                                   
                                    <Btn 
                                        type="button" 
                                        className={'btn'} 
                                        extraClassNames={['icon-btn', 'close']} 
                                        aria-label={'Sluiten van bekijk items'}
                                        aria-haspopup={false}                        
                                        tabIndex={0}                                                                                                                        
                                        onClick={() => close()}
                                        disabled={false}>
                                            <span className="close"></span>
                                    </Btn>                                                                                                                                                                                          
                                </div>
                                <div className={cx('flyover')}>
                                    {tabIndex===panel0 ? <AdminFilter></AdminFilter>:
                                                         <AdminFilterQuestions />}
                                </div>
                            </SlideView.Panel> 
                            <SlideView.Panel> {/* ***slideList = 1*** */}
                                <SlideView.Switch activeIndex={tabIndex}>
                                    <SlideView.Panel>  {/* ***panel0 = 0*** */}
                                        <div id="panel-0" role="tabpanel" aria-labelledby="tab-0" className={cx('tab-content')}>
                                            <div className={cx('active-page-filter')}>
                                            </div> 
                                            <div className={cx('tab-buttons')}>
                                                    <Wrapper updateAfterMount={true} thisButtonNo={buttonNotitiesToevoegenFlyover} updatedlock={() => UPDATED_BUTTON_LOCK({buttonNo: buttonNotitiesToevoegenFlyover, origin: originFlyover})}>
                                                        <Btn 
                                                            type="button" 
                                                            className={'btn'} 
                                                            extraClassNames={['icon-btn', 'plus']} 
                                                            aria-label={tabIndex===panel0 ? 'Nieuwe notitie aanmaken': 'Nieuwe bookmark aanmaken'}
                                                            aria-haspopup={true}                        
                                                            tabIndex={0}                                                              
                                                                onClick={()=> initiateNewNote()}
                                                            >
                                                                <span className="plus"></span>
                                                        </Btn>
                                                    </Wrapper>
                                                    <Btn 
                                                        type="button" 
                                                        className={'btn'} 
                                                        extraClassNames={['icon-btn', 'filter']} 
                                                        aria-label={'Filteren van notities'}
                                                        aria-haspopup={true}                        
                                                        tabIndex={0}                                                                                                                        
                                                        onClick={() => showFilter()}
                                                        disabled={false}>
                                                            <span className="filter"></span>
                                                    </Btn>   
                                                    <AdminFilterRemoveAllFiltersButton></AdminFilterRemoveAllFiltersButton>   
                                                    <Btn
                                                        type="button" 
                                                        className={'btn'} 
                                                        extraClassNames={['icon-btn', 'close']} 
                                                        aria-label={'Sluiten van bekijk items'}
                                                        aria-haspopup={false}                        
                                                        tabIndex={0}                                                                                                                        
                                                        onClick={() => close()}
                                                        disabled={false}>
                                                        <span className="close"></span>
                                                    </Btn>                                                                                                                                                                                                       
                                            </div>
                                            <div className={cx('item-container')}>
                                                <div className={cx('current_page-header')}>{`Huidige pagina (${currentPageNotes.length})`}</div>
                                                    {currentPageNotes&&currentPageNotes.length ? null : 
                                                        <div className={cx('no-items-container')}  dangerouslySetInnerHTML={{__html: NoItemsIcon}} />}
                                                    <DataList empty="Geen items gevonden" items={currentPageNotes
                                                            .map((itm) => new NoteAndParticipant(itm, participants.qWhere((i)=>i.id===itm.userId).qFirst()))} />
                                                <div className={cx('current_page-header')}>{`Overige (${otherPageNotes.length})`}</div>
                                                    {otherPageNotes&&otherPageNotes.length ? null : 
                                                        <div className={cx('no-items-container')}  dangerouslySetInnerHTML={{__html: NoItemsIcon}} />} 
                                                    <DataList empty="Geen items gevonden" items={otherPageNotes
                                                            .map((itm) => new NoteAndParticipant(itm, participants.qWhere((i)=>i.id===itm.userId).qFirst()))} />
                                            </div>
                                        </div>
                                        
                                    </SlideView.Panel>
{/*         */}
                                    <SlideView.Panel>  {/* ***panel1 = 1*** */}
                                        <div id="panel-1" role="tabpanel" aria-labelledby="tab-1" className={cx('tab-content')}>
                                            <div className={cx('active-page-filter')}>
                                            </div> 
                                            <div className={cx('tab-buttons')}>
                                                    <Wrapper updateAfterMount={true} thisButtonNo={buttonNotitiesToevoegenFlyover} updatedlock={() => UPDATED_BUTTON_LOCK({buttonNo: buttonNotitiesToevoegenFlyover, origin: originFlyover})}>
                                                        <Btn 
                                                            type="button" 
                                                            className={'btn'} 
                                                            extraClassNames={['icon-btn', 'plus']} 
                                                            aria-label={tabIndex===panel0 ? 'Nieuwe notitie aanmaken': tabIndex===panel1? 'Nieuwe vraag aanmaken' : 'Nieuwe bookmark aanmaken'}
                                                            aria-haspopup={true}                        
                                                            tabIndex={0}                                                              
                                                                onClick={()=> initiateNewNote()}
                                                            >
                                                                <span className="plus"></span>
                                                        </Btn>
                                                    </Wrapper>
                                                    <Btn 
                                                        type="button" 
                                                        className={'btn'} 
                                                        extraClassNames={['icon-btn', 'filter']} 
                                                        aria-label={'Filteren van vragen'}
                                                        aria-haspopup={true}                        
                                                        tabIndex={0}                                                                                                                        
                                                        onClick={() => showFilter()}
                                                        disabled={false}>
                                                            <span className="filter"></span>
                                                    </Btn>   
                                                    <AdminFilterRemoveAllFiltersButton></AdminFilterRemoveAllFiltersButton>   
                                                    <Btn
                                                        type="button" 
                                                        className={'btn'} 
                                                        extraClassNames={['icon-btn', 'close']} 
                                                        aria-label={'Sluiten van bekijk items'}
                                                        aria-haspopup={false}                        
                                                        tabIndex={0}                                                                                                                        
                                                        onClick={() => close()}
                                                        disabled={false}>
                                                        <span className="close"></span>
                                                    </Btn>                                                                                                                                                                                                       
                                            </div>
                                            <div className={cx('deadline-questions-container')}>
                                                <DeadLineLabelFlyover />
                                            </div>
                                            <div className={cx('item-container')}>
                                                <div className={cx('current_page-header')}>{`Huidige pagina (${currentPageQuestions.length})`}</div>
                                                    {currentPageQuestions&&currentPageQuestions.length ? null : 
                                                        <div className={cx('no-items-container')}  dangerouslySetInnerHTML={{__html: NoItemsIcon}} />}
                                                    <DataList empty="Geen items gevonden" items={currentPageQuestions
                                                            .map((itm) => new NoteAndParticipant(itm, participants.qWhere((i)=>i.id===itm.userId).qFirst()))} />
                                                <div className={cx('current_page-header')}>{`Overige (${otherPageQuestions.length})`}</div>
                                                    {otherPageQuestions&&otherPageQuestions.length ? null : 
                                                        <div className={cx('no-items-container')}  dangerouslySetInnerHTML={{__html: NoItemsIcon}} />} 
                                                    <DataList empty="Geen items gevonden" items={otherPageQuestions
                                                            .map((itm) => new NoteAndParticipant(itm, participants.qWhere((i)=>i.id===itm.userId).qFirst()))} />
                                            </div>
                                        </div>
                                        
                                    </SlideView.Panel>
{/*         */}
                                    <SlideView.Panel> {/* ***panel2 = 2*** */}
                                        <div  id="panel-2" role="tabpanel" aria-labelledby="tab-2" className={cx('tab-content')}>
                                            <div className={cx('active-page-filter')}>
                                            </div> 
                                            <div className={cx('tab-buttons')}>
                                                    <Wrapper updateAfterMount={true} thisButtonNo={buttonNotitiesToevoegenFlyover} updatedlock={() => UPDATED_BUTTON_LOCK({buttonNo: buttonNotitiesToevoegenFlyover, origin: originFlyover})}>
                                                        <Btn 
                                                            type="button" 
                                                            className={'btn'} 
                                                            extraClassNames={['icon-btn', 'plus']} 
                                                            aria-label={'Nieuwe notitie aanmaken'}
                                                            aria-haspopup={true}                        
                                                            tabIndex={0}                                                              
                                                                onClick={() => addCurrentBookmark()}
                                                            >
                                                                <span className="plus"></span>
                                                        </Btn>
                                                    </Wrapper>       
                                                    <Btn 
                                                        type="button" 
                                                        className={'btn'} 
                                                        extraClassNames={['icon-btn', 'close']} 
                                                        aria-label={'Sluiten van bekijk items'}
                                                        aria-haspopup={false}                        
                                                        tabIndex={0}                                                                                                                        
                                                        onClick={() => close()}
                                                        disabled={false}>
                                                            <span className="close"></span>
                                                    </Btn>                                                                                                                                                                                                       
                                            </div>
                                            <div className={cx('item-container')}>
                                                <div className={cx('fav-list-title')}>Favorieten ({tagActiveBookmarks&&tagActiveBookmarks.length})</div>
                                                {tagActiveBookmarks&&tagActiveBookmarks.length ? null : 
                                                        <div className={cx('no-items-container')} dangerouslySetInnerHTML={{__html: NoItemsIcon}} />} 
                                                <DataList items={tagActiveBookmarks.map((itm) => new NoteAndParticipant(itm))} empty="Geen items gevonden" />
                                            </div>
                                        </div>
                                    </SlideView.Panel> 
                                </SlideView.Switch>
                            </SlideView.Panel>
                            
                            <SlideView.Panel>  {/* ***slideDetails = 2*** */}  
                                <CategoryPopupSelection mode="edit"/>
                                <CategoriesEditArea />
                                <ParticipantsSelectPopup />
                                <FlyoverNotesEditLayout />
                                <FlyoverQuestionEditLayout />
                                <NoteSelection />
                                <NoteDeleteArea />
                                <Navigator />
                                <NoteChatEditArea />                                
                            </SlideView.Panel>                                                           
                        </SlideView.Switch> 
                        <SlideView.Switch className={'bottom_panel'} activeIndex={(pageFilterVisible ? slideFilter : (note || noteShared || deleting || visibleSelect||creating || updating ? slideDetails: slideList))}>             
                            <SlideView.Panel> {/* ***slideFilter = 0*** */}
                                {/* <Caption title="Filter instellen" /> */}
                            </SlideView.Panel>                        
                            <SlideView.Panel> {/* ***slideList = 1*** */}
                                <div className={cx('tab-buttons-bottom-row')}>
                                    <TabsSelector activeIndex={tabIndex} 
                                        containerClass={'footer'}
                                        onChange={activateTab}
                                        smallScreen={screenSmall}>                                                             
                                        <Btn 
                                            type="tab" 
                                            id="tab-0"
                                            title="Notities"
                                            className={'btn'} 
                                            extraClassNames={cx('text-icon-button')} 
                                            aria-controls="panel-0"
                                            aria-haspopup={false}                        
                                            tabIndex={0}   
                                            aria-selected={tabIndex===panel0}                                                                                                                   
                                            disabled={false}>
                                                <span>Notities</span>
                                        </Btn>   
                                        <Btn 
                                            type="tab" 
                                            id="tab-1"
                                            title="Technische Vragen"
                                            className={'btn'} 
                                            extraClassNames={cx('text-icon-button')} 
                                            aria-controls="panel-1"
                                            aria-haspopup={false}                        
                                            tabIndex={0}   
                                            aria-selected={tabIndex===panel1}
                                            disabled={false}>
                                                <span>Vragen</span>
                                        </Btn>                                           
                                        <Btn 
                                            type="tab" 
                                            id="tab-2"
                                            title="Favorieten"
                                            className={'btn'} 
                                            extraClassNames={['text-icon-button']} 
                                            aria-controls="panel-2"
                                            aria-haspopup={false}                        
                                            tabIndex={0}   
                                            aria-selected={tabIndex===panel2}                                                                                                                 
                                            disabled={false}>
                                                <span>Favorieten</span>
                                        </Btn>                                         
 
                                    </TabsSelector>
                                </div>                                
                            </SlideView.Panel>                            
                            <SlideView.Panel> {/* ***slideDetails = 2*** */} 
                                <Navbar visible={navbarVisible} typeName="Notitie" 
                                    index={tabIndex===panel0 ? index + 1: indexQuestion + 1} 
                                    count={tabIndex===panel0 ? currentPageNotes.length:currentPageQuestions.length} 
                                    onPrev={() => tabIndex===panel0 ? read(prev): readQuestion(prevQuestion, allQuestions)} 
                                    onNext={() => tabIndex===panel0 ? read(next): readQuestion(nextQuestion, allQuestions)} />                                                                       
                                <NoteSaveArea />
                                <QuestionSaveArea />
                                <NoteSelectionSave />
                                <CategorySelectModelSaveArea />
                                <CategoriesEditAreaButtons />
                                <NoteDeleteAreaSave />
                                <NoteChatSaveArea />
                            </SlideView.Panel>  
                        </SlideView.Switch>                       
                        </FocusLockFocusGuard>
                    </div>                
                </Modal>
        );
    });

function fixNoteDevelopmentJsonServer(item: IBookmark) {

    return item;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/flyover/index.tsx